import { Input, InputRef, Table } from "antd"
import { useState, useRef, useEffect } from "react"
import styles from './styles.module.less'
import { createStyles } from 'antd-style';

interface PhaseTableProps {
 phases: Array<{title: string, key: string}>
 data: any
}

export const PhaseTable = (props: PhaseTableProps) => {
  const {phases, data} = props;
  console.log(data)
  const columns = [
    {
      title: 'Phase',
      dataIndex: 'name',
      key: 'name',
      fixed: true,
      className: styles.rowTitle,
      render: (name, record) => {
        if (record.component) {
          return <span className="ml-2">{name}</span>
        }
        return name
      }
    },
    ...phases.map(item => {
      return {
        title: item.title,
        dataIndex: item.key,
        key: item.key,
        render: (text, record) => {
          return <EditableCell record={record}>{text}</EditableCell>
        }
      }
    })
  ]
  return <div>
    <Table
      bordered
      dataSource={data}
      columns={columns}
      size="small"
      pagination={false}
      scroll={{ x: 'max-content' }}
      className={styles.customTable}
    />
  </div>
}

interface EditableCellProps {
  record: any;
  handleSave?: (record: any) => void;
}

const EditableCell: React.FC<React.PropsWithChildren<EditableCellProps>> = ({
  children,
  record,
  handleSave,
  ...restProps
}) => {
  const [value, setValue] = useState(children);
  const [editing, setEditing] = useState(false);
  const inputRef = useRef<InputRef>(null);

  useEffect(() => {
    if (editing) {
      inputRef.current?.focus();
    }
  }, [editing]);

  const toggleEdit = () => {
    setEditing(!editing);
  };

  const save = async () => {
    toggleEdit();
  };

  let childNode = children;

  childNode = (
    <div
      className="editable-cell-value-wrap"
      onClick={toggleEdit}
    >
      {editing && <Input
        ref={inputRef}
        onPressEnter={save}
        onBlur={save}
        value={record.fraction}
        style={{width: '100%', height: 34}}
      />}
      {!editing && children}
    </div>
  );

  return <td {...restProps}>{childNode}</td>;
};

const useStyle = createStyles(({ css, token }) => {
  const antCls = 'ant'
  return {
    customTable: css`
      ${antCls}-table {
        ${antCls}-table-container {
          ${antCls}-table-body,
          ${antCls}-table-content {
            scrollbar-width: thin;
            scrollbar-color: #eaeaea transparent;
            scrollbar-gutter: stable;
          }
        }
      }
    `,
  };
});